import { CallGroup } from "~/types";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "~/apis/requests/useApiCall";
import { Pagination } from "~/types/pagination";

export const useCallGroupStore = definePiniaStore("callGroupStore", {
  state: () => ({
    showEditCallGroupModal: false,
    showCreateCallGroupModal: false,
    _tableData: [] as Array<CallGroup>,
    _loading: true,
    _pagination: {} as Pagination,
    _selectedCallGroupForEdit: {} as CallGroup,
  }),
  actions: {
    async getCallGroups() {
      this._loading = true;
      const { response, error } = await getRequest<CallGroup[]>(
        "cc/call-groups"
      );
      if (!error) {
        this.$state._tableData = response.data;
      }
      this._loading = false;
    },
    async createCallGroup(callGroup: CallGroup) {
      const { response, error } = await postRequest<CallGroup>(
        `cc/call-groups`,
        callGroup
      );
      if (!error) return response.data;
      return null;
    },
    async updateCallGroup(callGroup: CallGroup) {
      const { response, error } = await putRequest<CallGroup>(
        `cc/call-groups/${callGroup.id}`,
        callGroup
      );
      if (!error) {
        this.$state._selectedCallGroupForEdit = response.data;
        return response.data;
      }
      return null;
    },
    async deleteCallGroup(callGroup: CallGroup) {
      await deleteRequest(`cc/call-groups/${callGroup.id}`);
    },

    // mutations
    setEditModalVisibility(value: boolean) {
      this.showEditCallGroupModal = value;
    },
    setCreateModalVisibility(value: boolean) {
      this.showCreateCallGroupModal = value;
    },
    setCallGroupForEdit(callGroup: CallGroup) {
      this._selectedCallGroupForEdit = callGroup;
    },
  },

  getters: {
    tableData: (state) => state._tableData,
    selectedCallGroupForEdit: (state) => state._selectedCallGroupForEdit,
  },
});
